import React, { useContext, useState } from 'react';
import { useLocation } from "react-router-dom";
import { SearchIcon } from '../../icons/Search';
import { Input } from '../Input';
import { useURLQuery } from "../../hooks/useURLQuery";
import { CardsContext } from "../../CardsContext";
import './SearchInput.scss';

export function SearchInput({ value, ...props }) {
  const { routes } = useContext(CardsContext);
  const location = useLocation();
  const urlQuery = useURLQuery();
  const [defaultValue] = useState(() => {
    const searchParam = location.pathname === routes.search && urlQuery.get('query');
    return searchParam || undefined;
  });

  return (
    <Input
      allowClear
      className="SearchInput"
      prefix={<SearchIcon color="#8898AE"/>}
      placeholder="Search..."
      defaultValue={defaultValue}
      value={value || undefined}
      {...props}
    />
  );
}
